import React, { useEffect, useState } from "react";
import { cibilTable } from "../assets/data/cibilTable";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import GaugeChart from "react-gauge-chart";

const UserCibil = () => {
  const { user } = useSelector((state) => state.user);
  const [data1, setData1] = useState(user.Cibil_And_Loan_Details);
  const [data2, setData2] = useState(user.Cibil_And_Loan_Details);
  const [score, setScore] = useState(user.Credit_Score);
  const [summary, setSummary] = useState({
    Total_Santion_Amount: 0,
    Total_Current_Balance: 0,
    Total_EMI_Amount: 0,
  });
  const [filterInputs, setFilterInputs] = useState({
    status: "",
    entries: "All",
  });
  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs({
      ...filterInputs,
      [name]: value,
    });
  };
  const filterData = () => {
    const filtered = data1.filter((item) => {
      const statusFilter = filterInputs.status?.toLowerCase();
      const matchesStatus =
        !statusFilter ||
        (statusFilter === "active" && item.currentBalance > 0) ||
        (statusFilter === "closed" && item.currentBalance <= 0);

      return matchesStatus;
    });
    let tempSA = 0;
    let tempCB = 0;
    let tempEMI = 0;
    filtered.forEach((item) => {
      tempSA += item.highCreditAmount;
      tempCB += item.currentBalance;
      tempEMI += item.emiAmount;
    });
    setSummary({
      Total_Santion_Amount: tempSA,
      Total_Current_Balance: tempCB,
      Total_EMI_Amount: tempEMI,
    });
    console.log(summary);
    setData2(filtered);
  };
  useEffect(() => {
    filterData();
  }, [filterInputs]);
  const resetFilter = () => {
    setFilterInputs({
      status: "",
      entries: "All",
    });
    setData2(data1);
  };
  //
  const formatCurrency = (amount) =>
    amount && !isNaN(amount)
      ? `Rs ${Number(amount).toLocaleString("en-IN")}`
      : "0";
  //
  const [percentage, setPercentage] = useState(0);
  const [status, setStatus] = useState("");
  const [cibilColor, setCibilColor] = useState("#999");
  useEffect(() => {
    if (user && user.Credit_Score) {
      const score = user.Credit_Score;

      getCibilPercentage(user.Credit_Score);

      if (score >= 300 && score <= 549) {
        setCibilColor("#FF4D4F");
        setStatus("Poor");
      } else if (score >= 550 && score <= 649) {
        setCibilColor("#FFA940");
        setStatus("Fair");
      } else if (score >= 650 && score <= 749) {
        setCibilColor("#73D13D");
        setStatus("Good");
      } else if (score >= 750 && score <= 799) {
        setCibilColor("#52C41A");
        setStatus("Very Good");
      } else if (score >= 800 && score <= 900) {
        setCibilColor("#237804");
        setStatus("Excellent");
      } else {
        setCibilColor("#999");
        setStatus("");
      }
    }
  }, [user]);

  function getCibilPercentage(score) {
    const minScore = 300;
    const maxScore = 900;
    if (score < minScore || score > maxScore) {
      return "Invalid CIBIL score";
    }
    const percentage = (score - minScore) / (maxScore - minScore);
    setPercentage(Number(percentage.toFixed(2)));
  }
  return (
    <>
      <div className="container p-2">
        <div className="text-center mb-4">
          <h2 className="mb-2">
            Welcome back <span className="fw-bold">{user.Full_Name}</span>
          </h2>
          <div className="mt-2">
            <p className="pb-2">
              Your CIBIL Score is
              <span className="fw-bold" style={{ color: cibilColor }}>
                {status}
              </span>
            </p>
            <div className="cibil-bar">
              <GaugeChart
                id="gauge-chart1"
                colors={["#FF4D4F", "#FFA940", "#73D13D", "#52C41A", "#237804"]}
                nrOfLevels={5}
                percent={percentage}
                arcWidth={0.2}
                cornerRadius={2}
                arcPadding={0.025}
                needleColor="#000"
                hideText={true}
                animate={true}
                style={{ width: "200px" }}
                formatTextValue={() => `${user.Credit_Score}`}
              />
              <small className="level1">300</small>
              <small className="level2">579</small>
              <small className="level3">669</small>
              <small className="level4">739</small>
              <small className="level5">900</small>
            </div>
            <div
              className="rounded border py-1 px-3 d-inline-block"
              style={{ background: cibilColor }}
            >
              <h2 className="fw-bold text-white">{user.Credit_Score}</h2>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap mb-2 row-gap-2">
          <h2 className="fw-bold">CIBIL Report Summary</h2>
          {user.Account_Status === "Active" && (
            <Link to="/" className="button d-inline-block ms-auto">
              <FaHome />
            </Link>
          )}
        </div>
        <div className="cibil-summary-grid">
          <div>
            <p className="fw-bold">Total Sanction amount</p>
            <p>
              Rs
              {summary.Total_Santion_Amount === 0
                ? Number(user.Total_Santion_Amount).toLocaleString()
                : Number(summary.Total_Santion_Amount).toLocaleString()}
            </p>
          </div>
          <div>
            <p className="fw-bold">Current balance</p>
            <p>
              Rs
              {summary.Total_Current_Balance === 0
                ? Number(user.Total_Santion_Amount).toLocaleString()
                : Number(summary.Total_Santion_Amount).toLocaleString()}
            </p>
          </div>
          <div>
            <p className="fw-bold">EMI amount</p>
            <p>
              Rs
              {summary.Total_EMI_Amount === 0
                ? Number(user.Total_EMI_Amount).toLocaleString()
                : Number(summary.Total_EMI_Amount).toLocaleString()}
            </p>
          </div>
          <div>
            <p className="fw-bold text-capitalize">
              {filterInputs.status === "" ? "Total" : filterInputs.status}
              Accounts
            </p>
            <p>{data2.length}</p>
          </div>
        </div>

        <div className="filter">
          <div>
            <label>Filter by Account Status</label>
            <select
              className="input"
              name="status"
              value={filterInputs.status}
              onChange={handleFilterInputs}
            >
              <option value="">Please select</option>
              <option value="active">Active</option>
              <option value="closed">Closed</option>
            </select>
          </div>
          <div>
            <label>Show Entries</label>
            <select
              className="input"
              name="entries"
              value={filterInputs.entries}
              onChange={handleFilterInputs}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="All">All</option>
            </select>
          </div>
          <button className="button w-100 text-center" onClick={resetFilter}>
            Reset Filter
          </button>
        </div>

        <div className="table-responsive mt-4">
          <table className="table table-bordered table-hover table-striped cibil-table">
            <thead>
              <tr>
                {cibilTable.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {data2
                .slice(
                  0,
                  filterInputs.entries === "All"
                    ? data1.length
                    : filterInputs.entries
                )
                .map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.memberShortName || ""}</td>
                      <td>{item.accountNumber || ""}</td>
                      <td>
                        {item.actualPaymentAmount.toString() === "-1"
                          ? 0
                          : formatCurrency(item.actualPaymentAmount)}
                      </td>
                      <td>{formatCurrency(item.highCreditAmount)}</td>
                      <td>
                        {item.dateOpened &&
                          item.dateOpened.split("-").reverse().join("-")}
                      </td>
                      <td>{formatCurrency(item.currentBalance)}</td>
                      <td>
                        {item.amountOverdue.toString() === "-1"
                          ? 0
                          : formatCurrency(item.amountOverdue)}
                      </td>
                      <td>{item.accountType || ""}</td>
                      <td>
                        {item.emiAmount.toString() === "-1"
                          ? 0
                          : formatCurrency(item.emiAmount)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default UserCibil;
